const generateReferenceNumber = (prefix) => {
  var today = new Date();
  const year = today.getFullYear();
  var month = today.getMonth() + 1;
  if(month < 10) month = '0' + month;
  var day = today.getDate();
  if(day < 10) day = '0' + day;
  const randomNo = Math.floor((Math.random() * 900000) + 100000);

  return (prefix + year + month + day + randomNo);
}

export default generateReferenceNumber;
